import React from 'react';
import { ImSpinner8 } from 'react-icons/im';

interface SelectedProductProps {
    quantity: number;
    className?: string;
    animated?: Boolean;
    loading?: Boolean;
    alwaysNotify?: Boolean;
    ring?: Boolean;
    color?: string;
    colorAnimation?: string;
}

const SelectedProduct = ({
    quantity,
    className = '',
    animated = true,
    loading = false,
    alwaysNotify = true,
    ring = false,
    color = 'shopfood-notify',
    colorAnimation = 'shopfood-notify'
}: SelectedProductProps) => {

    return (
        <div className={`absolute w-full h-full flex items-center justify-center font-medium bg-gray-800 bg-opacity-0 rounded-t-lg z-10 ${className}`}>
            <span className={`
                    z-25 rounded-full w-6 h-6 md:w-7 md:h-7 flex items-center justify-center absolute -top-1 -right-1 md:-top-1.5 md:-right-1.5 
                    ${animated && 'zoomInIcon'}
                    ${(alwaysNotify || quantity > 0) ? `bg-${color} text-white` : ''}
                    ${ring ? 'ring-1 ring-white' : ''}
                    `}>
                <span className="text-xs md:text-sm font-extrabold leading-none">
                    {loading
                        ? <ImSpinner8 className="animate-spin" size={14} />
                        : quantity > 0 ? quantity : ''
                    }
                </span>
            </span>
            <span className={`${(alwaysNotify || quantity > 0) ? `bg-${colorAnimation}` : ''} z-20 rounded-full w-6 h-6 md:w-7 md:h-7 flex items-center justify-center absolute -top-1 -right-1 md:-top-1.5 md:-right-1.5 ${animated && 'animate-ping'}`}></span>
        </div>
    );
};

export default SelectedProduct;
